import React from "react";

const JQuery_Animate = () => {
  return (
    <div>
      <h1>JQuery_Animate</h1>
      <p>Placeholder component for: "JQuery_Animate"</p>
    </div>
  );
};

export default JQuery_Animate;
